/**
 * Shared LO Compensation extractor.
 *
 * Base compensation comes from the Encompass ProfitMargin "LO Compensation" row,
 * NOT from the local loan_pricing_items amount. The local row is metadata only
 * (reduction_bps + payee override).
 */

import type { RateLockPriceAdjustment } from '@/components/encompass/prospects/types';

/**
 * Extract LO Compensation bps from Encompass buy-side adjustments.
 * Matches ProfitMargin rows with description "LO Compensation" (case-insensitive, trimmed).
 * If multiple matching rows exist, sums them.
 */
export function extractEncompassLoCompBps(
  adjustments: RateLockPriceAdjustment[] | undefined | null
): number {
  if (!adjustments) {
    return 0;
  }
  return adjustments
    .filter(a =>
      a.priceAdjustmentType === 'ProfitMargin' &&
      a.description?.trim().toLowerCase() === 'lo compensation'
    )
    .reduce((sum, a) => sum + Math.abs(a.rate) * 100, 0); // rate is points (e.g., -1.25) → bps (125)
}
